import(/* webpackMode: "eager" */ "/var/www/higuard/frontend/src/app/login/page.tsx");
